import { accountActions } from 'core/Account';
import { dashboardActions } from './';
import { eventChannel } from 'redux-saga';
import { patientActions } from 'core/Patient';
import { professionalActions } from 'core/Professional';
import rootService from 'core/services.root';
import { turnsActions } from 'core/Turns';

export default rootService({
    getCallTracking: ['GET', '/global/log/call/:call_id'],
    getCallsListPage: ['GET', '/call/listing/paginated'],
    getProfessionalsList: ['GET', '/doctor/paginated']
});

export const socketService = socket => eventChannel(emit => {

    socket.on('appointments-deleted', (channel, { ids }) => emit(turnsActions.handleAppointmentsDelete(ids)));

    socket.on('confirm-validation', (channel, { user: { first_name, last_name } }) => {
        emit(professionalActions.setProfessionalNotificationResponse(`El profesional ${ first_name } ${ last_name } ha confirmado la recepción de la notificación del administrador`));
    });

    socket.on('new-appointment', (channel, { appointment }) => emit(turnsActions.updateSingleAppointment(appointment)));

    socket.on('patient-import-finished', (channel, data) => emit(patientActions.handleImportPatientsFinished(data)));

    socket.on('patient-import-updated', (channel, data) => emit(patientActions.handleImportPatientsUpdated(data)));

    socket.on('permissions-updated', (channel, { locked_actions }) => emit(accountActions.replaceAccountUser({ locked_actions })));

    socket.on('status-update', (channel, data) => emit(dashboardActions.handleSocketEvent(data)));

    socket.on('update-appointment', (channel, { appointment }) => emit(turnsActions.updateSingleAppointment(appointment)));

    return () => {};
});
